import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _PropTypes from 'prop-types';
import * as React from 'react';
import { AccordionContext } from '../AccordionContext/AccordionContext.js';
import { AccordionGroup } from '../AccordionGroup/AccordionGroup.js';
import { AccordionHeader } from '../AccordionHeader/AccordionHeader.js';
import { AccordionItem } from '../AccordionItem/AccordionItem.js';
import { AccordionItemContext } from '../AccordionItemContext/AccordionItemContext.js';
import { AccordionPanel } from '../AccordionPanel/AccordionPanel.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var Accordion = /*#__PURE__*/React.forwardRef(function Accordion2(props, ref) {
  var accordion = props.accordion,
      accordionContextProps = props.accordionContextProps;
  var accordionElements = accordion.map(function (a) {
    return {
      headerElement: /*#__PURE__*/jsx(AccordionHeader, _objectSpread({}, a.headerProps)),
      panelElement: /*#__PURE__*/jsx(AccordionPanel, _objectSpread({}, a.panelProps))
    };
  });
  return /*#__PURE__*/jsx(AccordionContext, _objectSpread(_objectSpread({}, accordionContextProps), {}, {
    children: /*#__PURE__*/jsx(AccordionGroup, {
      ref: ref,
      children: accordionElements.map(function (ae, i) {
        return /*#__PURE__*/jsx(AccordionItemContext, {
          index: i,
          children: /*#__PURE__*/jsxs(AccordionItem, {
            children: [ae.headerElement, ae.panelElement]
          })
        }, i);
      })
    })
  }));
});
Accordion.propTypes = {
  "accordion": _PropTypes.arrayOf(_PropTypes.shape({
    "headerProps": _PropTypes.object.isRequired,
    "panelProps": _PropTypes.object.isRequired
  })).isRequired,
  "accordionContextProps": _PropTypes.shape({
    "defaultIndex": _PropTypes.arrayOf(_PropTypes.number)
  })
};
Accordion.displayName = "Accordion";

export { Accordion };
